import { Pin } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgPin = mkIcon(Pin);